export default function LinkedInCallbackPage() {

  return null;
}
